var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRighttick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7071 0.945237C17.0976 1.33576 17.0976 1.96893 16.7071 2.35945L8.12132 10.9452C6.94975 12.1168 5.05026 12.1168 3.87868 10.9452L0.292893 7.35945C-0.0976311 6.96893 -0.0976311 6.33576 0.292893 5.94524C0.683417 5.55471 1.31658 5.55471 1.70711 5.94524L5.29289 9.53102C5.68342 9.92155 6.31658 9.92155 6.70711 9.53102L15.2929 0.945237C15.6834 0.554713 16.3166 0.554713 16.7071 0.945237Z",
    fill: "#B5E4CA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRighttick);
export default __webpack_public_path__ + "static/media/Righttick.53a1d0073e9a3c38e071a908e747c58e.svg";
export { ForwardRef as ReactComponent };